import { render, staticRenderFns } from "./EmployeeImage.vue?vue&type=template&id=28412fa4&scoped=true&"
import script from "./EmployeeImage.vue?vue&type=script&lang=js&"
export * from "./EmployeeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28412fa4",
  null
  
)

export default component.exports